import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/Actions/actions";
import "./Templates.scss";
import Loader from "../../../../assets/images/spinner.gif";
import * as UTILS from "../../../../utils/Utils";
import Popup from "../../../Modal/Popup";
import shortid from "shortid";
import "bootstrap/dist/css/bootstrap.min.css";
import DeleteIco from "../../../../assets/images/delete.svg";
import Confirm from "../../../Modal/Confirm";
import Rename from "../../../../assets/images/edit-noBorder.svg";
import noImage from "../../../../assets/images/noimage.png";
import cloneDeep from "lodash.clonedeep";
import { Alert } from "reactstrap";
import { track } from "@amplitude/analytics-browser";
import Axios from "../../../../axios";
const Templates = (props) => {
  const [state, setState] = useState({
    pageToQuery: 1,
    currentPage: 1,
    templates: null,
    unfilteredTemplates: null,
    templateID: null,
    templateLoaded: false,
    templateDATA: [],
    loader: false,
    templateSetting: null,
    deleteStatus: "none",
    renameStatus: "none",
    deleteTemplateItem: false,
    deleteTemplateID: null,
    renamedTemplateID: null,
    renameClicked: false,
    templateTitleEnable: null,
    templateTitle: "",
    brokenLinkImage: [],
    scrollCall: false,
    renamed: false,
    deleted: false,
    disableButton: true,
  });
  const scrollRef = useRef(null);
  const inputRef = useRef(null);
  const stateRef = useRef(state);
  stateRef.current = state;

  useEffect(() => {
    getTemplateThumbs();
    track("Templates Modal Opened", {
      triggerAction: "Navigation Item",
    });
  }, []);

  useEffect(() => {}, [state.templates]);

  useEffect(() => {
    if (state.renamed === true || state.deleted === true) {
      getTemplateThumbs();
    }
  }, [state.deleted, state.renamed]);

  useEffect(() => {
    if (state.templateID !== null) {
      getTemplateData();
    }
  }, [state.templateID]);

  const getTemplateThumbs = () => {
    if (state.templates === null || undefined) {
      setState({
        ...state,
        loader: true,
      });
    }
    const comparefn = (a, b) => {
      const a_date = new Date(a.created_at);
      const b_date = new Date(b.created_at);

      return b_date - a_date;
    };

    Axios.TemplateService.GET_TEMPLATE_THUMBNAILS(
      props.userID,
      props.sessionID,
      `t&page=${state.pageToQuery}`
    )
      .then((response) => {
        if (response.status == 200) {
          if (state.templates === null || undefined) {
            const dateSortedTemplates =
              response.data.data.custom.sort(comparefn);

            setState({
              ...state,
              templates: response.data.data.custom ? dateSortedTemplates : [],
              unfilteredTemplates: response.data.data.custom
                ? dateSortedTemplates
                : [],
              templatesReady: response.data.data.custom ? true : false,
              loader: false,
              scrollCall: false,
              pageToQuery: state.pageToQuery + 1,
              renamed: false,
              deleted: false,
            });
          } else {
            const dateSortedTemplates =
              response.data.data.custom.sort(comparefn);
            setState({
              ...state,
              templates: [...state.templates, ...dateSortedTemplates],
              unfilteredTemplates: [...state.templates, ...dateSortedTemplates],
              templatesReady: response.data.data.custom ? true : false,
              loader: false,
              scrollCall: false,
              pageToQuery: state.pageToQuery + 1,
              renamed: false,
              deleted: false,
            });
          }
          track("Templates Loaded", {
            templateCount: state.templates.length,
          });
        }
      })
      .catch((error) => {
        // Error in creating snapshot
      });
  };

  const getTemplateData = () => {
    if (state.templateID !== null) {
      Axios.TemplateService.GET_TEMPLATE_DATA(
        state.templateID,
        props.userID,
        props.sessionID
      ).then((response) => {
        const templateDataConverted = JSON.parse(
          response.data.data.template_data
        );

        setState({
          ...state,
          templateID: response.data.data.template_id,
          templateDATA: templateDataConverted,
          disableButton: false,
        });
      });
    }
  };

  const chooseTemplate = () => {
    if (state.templateDATA.layout == [] || null || undefined) {
      alert("nothing selected");
      return;
    }

    const selected = state.templateID;

    const layoutData = UTILS.PushWithID(state.templateDATA.layout);

    if (layoutData) {
      setState({
        ...state,
        templateLoaded: true,
      });

      props.pushFlimpTemplateID(selected);

      props.layoutArray(props.layoutTitle, layoutData);

      props.closeTemplatesPopup();
    }
    track("Template Selected", {
      templateId: state.templateID,
      templateName: state.templateTitle,
      category: null,
    });
  };
  const deleteBlock = (tempID, isDefTemp) => {
    let data = {
      u: props.userID,
      sn: props.sessionID,
      t: tempID,
      isDef: isDefTemp,
    };

    Axios.TemplateService.POST_TEMPLATE_DELETE(data).then((response) => {
      if (response.data.statusCode == "success") {
        // setTimeout
        setState(
          {
            ...state,
            templates: null,
            pageToQuery: 1,
            deleted: true,
            deleteStatus: "success",
            deleteTemplateID: null,
            deleteTemplateID: null,
          },
          setTimeout(onDismissDelete, 4000)
        );
      } else {
        setState(
          {
            ...state,
            deleteStatus: "danger",
          },
          setTimeout(onDismissDelete, 4000)
        );
      }
    });
  };
  const onDismissDelete = () => {
    setState({ ...stateRef.current, deleteStatus: "none" });
  };
  const onDismissRename = () => {
    setState({ ...stateRef.current, renameStatus: "none" });
  };

  const renameTitle = (indexToStateUpdate, isDefTemp) => {
    setState({
      ...state,
    });
    inputRef.current.value = "";
    const data = {
      u: props.userID,
      sn: props.sessionID,
      nm: state.templateTitle,
      id: state.templateTitleEnable,
      isDef: isDefTemp,
      // templateTitleEnable
      // templateTitle
    };
    Axios.TemplateService.POST_TEMPLATE_NAME_UPDATE(data).then((response) => {
      if (response.data.statusCode === "success") {
        setState(
          {
            ...state,
            templates: null,
            templateID: null,
            pageToQuery: 1,
            renamed: true,
            templateTitle: null,
            templateTitleEnable: null,
            renameStatus: "success",
          },
          setTimeout(onDismissRename, 4000)
        );
      }
      if (response.data.statusCode != "success") {
        setState(
          {
            ...state,
            templates: null,
            templateID: null,
            pageToQuery: 1,
            renamed: true,
            templateTitle: null,
            templateTitleEnable: null,
            renameStatus: "danger",
          },
          setTimeout(onDismissRename, 4000)
        );
      }
    });
  };

  const handleChange = (evt, itemID) => {
    setState({
      ...state,
      templateTitle: evt.target.value,
    });
  };

  const handleScroll = async (evt) => {
    const scroller = scrollRef.current;

    if (
      scroller.scrollTop + scroller.clientHeight + 200 >=
        3223 * state.currentPage &&
      state.scrollCall === false
    ) {
      setState(
        {
          ...state,
          currentPage: state.page + 1,
          scrollCall: true,
        },
        getTemplateThumbs()
      );
    }
  };

  const searchTemplates = (event) => {
    const TEMPLATES = cloneDeep(state.unfilteredTemplates);

    let searchQuery = event.target.value.toLowerCase();
    const updatedCustom = TEMPLATES.filter((el) => {
      let searchValue =
        el.template_name !== null ? el.template_name.toLowerCase() : "";
      return searchValue.indexOf(searchQuery) !== -1;
    });

    if (updatedCustom == [] || searchQuery === "" || null | undefined) {
      setState({
        ...state,
        pageToQuery: 1,
        scrollCall: false,
        templateID: null,
        templates: state.unfilteredTemplates,
      });
    } else {
      setState({
        ...state,
        templateID: null,
        templates: updatedCustom,
        pageToQuery: 1,
        scrollCall: true,
      });
    }
  };

  return (
    <Popup
      width="700"
      header="Choose Layout Template"
      closePopup={props.closeTemplatesPopup}
      close={props.closeTemplatesPopup}
      save={() => {
        chooseTemplate();
      }}
      btnLabel="Select"
      parentID="templateWrap"
      disableButton={state.disableButton}
    >
      <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <input
          placeholder="Search Templates"
          ref={inputRef}
          className="templates-search"
          onChange={searchTemplates}
        ></input>
        <div>
          {state.deleteStatus == "success" ? (
            <Alert
              color="success"
              className="alert"
              fade={true}
              style={{ textAlign: "center" }}
              // toggle={onDismissDelete}
            >
              <p>Template Successfully Deleted</p>
            </Alert>
          ) : state.deleteStatus == "danger" ? (
            <Alert
              color="danger"
              className="alert"
              fade={true}
              style={{ textAlign: "center" }}
              // toggle={onDismissDelete}
            >
              <p>Error Deleting Template, Pleas try again.</p>
            </Alert>
          ) : state.renameStatus == "success" ? (
            <Alert
              color="success"
              className="alert"
              fade={true}
              style={{ textAlign: "center" }}
              // toggle={onDismissRename}
            >
              <p>Template Successfully Renamed</p>
            </Alert>
          ) : state.renameStatus == "danger" ? (
            <Alert
              color="danger"
              className="alert"
              fade={true}
              style={{ textAlign: "center" }}
              // toggle={onDismissRename}
            >
              <p>Error Renaming Template, Please try again.</p>
            </Alert>
          ) : (
            ""
          )}
        </div>
      </div>
      <div
        ref={scrollRef}
        onScroll={handleScroll}
        className="modalScrollContainer"
      >
        {state.loader ? (
          <div className="loadingBlock">
            <p>
              <img src={Loader} />
            </p>
            Templates are loading...
          </div>
        ) : state.templates !== null ? (
          <div>
            <div
              style={{
                margin: 0,
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {state.templates.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={
                      item.template_id === state.templateID
                        ? "selectedTemplate thumbWrapper"
                        : "thumbWrapper"
                    }
                  >
                    <img
                      className="templateThumb"
                      onClick={() => {
                        setState({
                          ...state,
                          templateID: item.template_id,
                          templateTitle: item.template_name,
                        });
                      }}
                      src={
                        state.brokenLinkImage.includes(item.template_id)
                          ? noImage
                          : item.thumb
                      }
                      onError={() => {
                        setState({
                          ...state,
                          brokenLinkImage: [
                            ...state.brokenLinkImage,
                            item.template_id,
                          ],
                        });
                      }}
                    ></img>

                    <div
                      data-id={item.template_id}
                      className={
                        "deleteBlock" +
                        (item.template_id == state.deleteTemplateID
                          ? " loadingActive"
                          : " ")
                      }
                    ></div>

                    {state.templateTitleEnable === item.template_id ? (
                      <div className="updateTitleWrapper">
                        <div className="updateTitle">
                          <input
                            className="change-title-input"
                            defaultValue={state.templateTitle}
                            onChange={(evt) => {
                              handleChange(evt, item.template_id);
                            }}
                            type="text"
                          />
                          <button
                            onClick={() => {
                              let isDefTemp = "Y";
                              renameTitle(index, isDefTemp);
                              setState({
                                ...state,
                                renamedTemplateID: item.template_id,
                              });
                            }}
                            className="save-title"
                          >
                            {state.renamedTemplateID === item.template_id ||
                            state.deleteTemplateID === item.template_id ? (
                              <div className="loading"></div>
                            ) : (
                              <i className="fas fa-check fa-md"></i>
                            )}
                          </button>
                          <i
                            className="fa fa-times closeCross fa-lg"
                            onClick={() => {
                              setState({
                                ...state,
                                templateTitleEnable: null,
                                templateTitle: null,
                              });
                            }}
                          ></i>
                          <Confirm
                            element="small"
                            getConfirmation={(status) => {
                              if (status) {
                                setState(
                                  {
                                    ...state,
                                    deleteTemplateID: item.template_id,
                                    deleteTemplateItem: item.template_id,
                                  },

                                  deleteBlock(item.template_id, "Y")
                                );
                              }
                            }}
                          >
                            {state.deleteTemplateID === item.template_id ? (
                              <button className="delete-Icon save-title">
                                <div className="loading"></div>
                              </button>
                            ) : (
                              <img className="delete-Icon2" src={DeleteIco} />
                            )}
                          </Confirm>
                        </div>
                      </div>
                    ) : (
                      <div className="clickHere">
                        {item.template_name === null || "" ? (
                          <div className="clickHere-cont">
                            <p
                              onClick={(e) => {
                                e.stopPropagation();
                                setState({
                                  ...state,
                                  templateTitleEnable: item.template_id,
                                  templateTitle: "",
                                });
                              }}
                              className="titleTemplate noTitle"
                            >
                              Click here to add title.
                            </p>
                            <Confirm
                              element="small"
                              getConfirmation={(status) => {
                                if (status) {
                                  setState(
                                    {
                                      ...state,
                                      deleteTemplateID: item.template_id,
                                      deleteTemplateItem: item.template_id,
                                    },

                                    deleteBlock(item.template_id, "Y")
                                  );
                                }
                              }}
                            >
                              {state.deleteTemplateID === item.template_id ? (
                                <button className="delete-Icon save-title">
                                  <div className="loading"></div>
                                </button>
                              ) : (
                                <img className="delete-Icon" src={DeleteIco} />
                              )}
                            </Confirm>
                          </div>
                        ) : (
                          ""
                        )}
                        {item.template_name !== null ? (
                          <div className="title-cont">
                            <div className="templateTitle">
                              {item.template_name}{" "}
                              <img
                                className="editIcon"
                                onClick={() => {
                                  setState({
                                    ...state,
                                    templateTitleEnable: item.template_id,
                                    templateTitle: item.template_name,
                                  });
                                }}
                                src={Rename}
                              ></img>
                            </div>
                            <Confirm
                              element="small"
                              getConfirmation={(status) => {
                                if (status) {
                                  setState(
                                    {
                                      ...state,
                                      deleteTemplateID: item.template_id,
                                      deleteTemplateItem: item.template_id,
                                    },

                                    deleteBlock(item.template_id, "Y")
                                  );
                                }
                              }}
                            >
                              {state.deleteTemplateID === item.template_id ? (
                                <button className="delete-Icon save-title">
                                  <div className="loading"></div>
                                </button>
                              ) : (
                                <img className="delete-Icon" src={DeleteIco} />
                              )}
                            </Confirm>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            {" "}
            <img src={Loader} />
          </div>
        )}
      </div>
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    selectedFont: state.present.selectedFont,
    layoutTitle: state.present.layoutTitle,
    flimpTemplateID: state.present.flimpTemplateID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushCanvasMarginUnit: (unit) =>
      dispatch(actionTypes.canvas_margin_unit(unit)),
    pushCanvasMargin: (margin) => dispatch(actionTypes.canvas_margin(margin)),
    pushCanvasPadding: (padding) =>
      dispatch(actionTypes.canvas_padding(padding)),
    pushCanvasPaddingUnit: (unit) =>
      dispatch(actionTypes.canvas_padding_unit(unit)),
    pushCanvasMarginMobile: (margin) =>
      dispatch(actionTypes.canvas_margin_mobile(margin)),
    pushCanvasPaddingMobile: (padding) =>
      dispatch(actionTypes.canvas_padding_mobile(padding)),
    pushCanvasRowsPaddingUnit: (unit) =>
      dispatch(actionTypes.canvas_rows_padding_unit(unit)),
    pushCanvasRowsPadding: (padding) =>
      dispatch(actionTypes.canvas_rows_padding(padding)),
    pushCanvasRowsPaddingMobile: (padding) =>
      dispatch(actionTypes.canvas_rows_padding_mobile(padding)),
    pushCanvasColumnGap: (gap) => dispatch(actionTypes.canvas_column_gap(gap)),
    pushCanvasRowGap: (gap) => dispatch(actionTypes.canvas_row_gap(gap)),
    push_navigation_style: (value) =>
      dispatch(actionTypes.navigation_style(value)),
    push_navigation_search: (value) =>
      dispatch(actionTypes.navigation_search(value)),
    canvasPush: (canvasVal) => dispatch(actionTypes.canvas(canvasVal)),
    push_navigation_align: (value) =>
      dispatch(actionTypes.navigation_align(value)),
    canvasPush: (canvasVal) => dispatch(actionTypes.canvas(canvasVal)),

    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSurroundBg: (color) => dispatch(actionTypes.add_bg_surround(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),

    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBgRepeat: (bgRepeat) => dispatch(actionTypes.bg_repeat(bgRepeat)),
    pushBgContainerRepeat: (bgRepeat) =>
      dispatch(actionTypes.bg_repeat_container(bgRepeat)),
    pushBgContainerSize: (bgSize) =>
      dispatch(actionTypes.bg_size_container(bgSize)),
    pushBgSize: (bgSize) => dispatch(actionTypes.bg_size(bgSize)),
    pushBGimage: (image, id) =>
      dispatch(actionTypes.bg_image({ bgImage: image, bgImageId: id })),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
    pushFlimpTemplateID: (index) => dispatch(actionTypes.flimp_tmp_id(index)),
    pushBGContainerimage: (image, id) =>
      dispatch(
        actionTypes.bg_image_container({
          bgImageContainer: image,
          bgImageContainerId: id,
        })
      ),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    hamburger_color: (color) => dispatch(actionTypes.hamburger_color(color)),
    push_hamburger_menu: (value) => dispatch(actionTypes.hamburger_menu(value)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    reorderLayoutList: (list) =>
      dispatch(actionTypes.reorder_layout_list(list)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Templates);
